var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { ref: "wrapper", staticClass: "zoom-slider-wrapper" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/zoom/ZoomSliderWrapper.vue?vue&type=template&id=7c5f5a02&scoped=true&
// module id = 533
// module chunks = 0